module.exports = __webpack_public_path__ + "./docs/img/icon-module.da9545f7262111085da236a2044ca8a8.svg";